import { render, staticRenderFns } from "./addAssociatModel.vue?vue&type=template&id=56827f96&scoped=true&"
import script from "./addAssociatModel.vue?vue&type=script&lang=js&"
export * from "./addAssociatModel.vue?vue&type=script&lang=js&"
import style0 from "./addAssociatModel.vue?vue&type=style&index=0&id=56827f96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56827f96",
  null
  
)

export default component.exports